import { render, staticRenderFns } from "./FlatButton.global.vue?vue&type=template&id=705e8e9f&scoped=true&lang=pug&"
import script from "./FlatButton.global.vue?vue&type=script&lang=ts&"
export * from "./FlatButton.global.vue?vue&type=script&lang=ts&"
import style0 from "./FlatButton.global.vue?vue&type=style&index=0&id=705e8e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e8e9f",
  null
  
)

export default component.exports